(function(){
    angular
        .module('maApp.validation')
        .directive('pbDateMonthDay', pbDateMonthDay);

    pbDateMonthDay.$inject = [];

    function pbDateMonthDay(){
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {

                ctrl.$validators.pbDateMonthDay = pbDateMonthDayValidator;

                function pbDateMonthDayValidator() {
                    //normalize the values
                    var form = scope.managementActionForm;
                    var startmonth = form.startmonth.$viewValue.length ? parseInt(form.startmonth.$viewValue) - 1 : null;
                    var startday = form.startday.$viewValue.length ? parseInt(form.startday.$viewValue): null;
                    var endmonth = form.endmonth.$viewValue.length ? parseInt(form.endmonth.$viewValue) - 1 : null;
                    var endday = form.endmonth.$viewValue.length ? parseInt(form.endday.$viewValue) : null;

                    var validatingStart = ('pbIsMonthBefore' in attrs) || ('pbIsDayBefore' in attrs),
                        validatingEnd = ('pbIsMonthAfter' in attrs) || ('pbIsDayAfter' in attrs),
                        isValid = null;

                    var willEvaluateStart = validatingStart && startmonth !== null && startday !== null;
                    var willEvaluateEnd = validatingEnd && endmonth !== null && endday !== null;

                    if( willEvaluateStart ){
                        isValid = startday <= Date.create().set({month: startmonth}).daysInMonth();
                    }else if( willEvaluateEnd ){
                        isValid = endday <= Date.create().set({month: endmonth}).daysInMonth();
                    } else {
                        isValid = true;    //can't validate without all fields
                    }

                    return isValid;

                }
            }
        };
    }
})();